const marionette = require('backbone.marionette'),
    template = require('appLoginLayout.hbs'),
    moment = require('moment'),
    switchLanguage = require('shared/helpers/switchLanguage'),
    getLanguage = require('shared/helpers/getLanguage'),
    constants = require('shared/helpers/constants'),
    bowser = require('bowser'),
    BadBrowserModalView = require('badBrowserModalView'),
    Radio = require('backbone.radio'),
    getCookie = require('shared/helpers/getCookie');

const channel = Radio.channel('login');

module.exports = marionette.View.extend({
    template: template,
    ui: {
        language: '#language a',
        terms: '#terms',
    },
    events: {
        'click @ui.language': 'onSwitchLanguage',
    },
    regions: {
        mainRegion: {
            el: '#mainRegion',
            replaceElement: true
        },
        badBrowserModalRegion: '#badBrowserModalRegion'
    },
    // I don't for the life of me remember why, but this is how we have to
    // implement templateContext on this view.  Make any changes to templateContext within the
    // initialize code, below.
    templateContext: {},
    initialize: function () {
        this.templateContext.year = moment().format('YYYY');
        this.templateContext.version = constants.wellDriveVersion;
        // Apparently, if this require is put at the top, translations fail?
        // We should eventually find out why.
        this.templateContext.M = require('shared/messages/messages');
        this.templateContext.languages = constants.languages;
    },
    onRender: function () {
        let modalView = new BadBrowserModalView();
        this.showChildView('badBrowserModalRegion', modalView);
    },
    onDomRefresh: function () {
        // Browser check.
        let browser = this.getBrowserSupport();
        if (!browser.supported) {
            if (!getCookie('badBrowserConfirmed')) {
                channel.trigger('badBrowser');
            }
        }
        // Set the footer TandC popup window link appropriately for the selected language.
        this.ui.terms.off('click');
        switch (getLanguage()) {
            case 'es':
                this.ui.terms.on('click', this.termsAndConditionsPopup_es);
                break;
            default:
                this.ui.terms.on('click', this.termsAndConditionsPopup);
        }
    },
    onSwitchLanguage: function (e) {
        e.preventDefault();
        let selectedLanguage = $(e.target).attr('isocode');
        switchLanguage(selectedLanguage, true);
    },
    termsAndConditionsPopup: function () {
        window.open('welldriveTermsAndConditions.html', '_blank', 'width=800, height=500, top=50, left=50, scrollbars=yes, resizable=yes, titlebar=yes');
        return false;
    },
    termsAndConditionsPopup_es: function () {
        window.open('welldriveTermsAndConditions_es.html', '_blank', 'width=800, height=500, top=50, left=50, scrollbars=yes, resizable=yes, titlebar=yes');
        return false;
    },
    getBrowserSupport: function () {
        let result = {};
        result.supported = false;
        if (constants.supportedBrowsers[bowser.name.toLowerCase().replace(' ', '')]) {
            result.supported = true;
        }
        return result;
    }
});
